import type { ValidatorMapFunc } from 'ember-changeset/types';
import { makeArray } from 'garaje/utils/make-array';

interface ConditionalOptions {
  if: ValidatorMapFunc;
  then?: ValidatorMapFunc;
  else?: ValidatorMapFunc;
}

export default function conditional(options: ConditionalOptions): ValidatorMapFunc[] {
  const thenValidators = makeArray(options.then);
  const elseValidators = makeArray(options.else);
  const max = Math.max(thenValidators.length, elseValidators.length);

  // A single validator can't return an array of validations,
  // so we return an array of validators instead :/
  const validators = [];
  for (let i = 0; i < max; i++) {
    validators.push(makeValidator(options.if, thenValidators[i], elseValidators[i]));
  }
  return validators;
}

function makeValidator(
  condition: ValidatorMapFunc,
  thenValidator?: ValidatorMapFunc,
  elseValidator?: ValidatorMapFunc,
) {
  const validator: ValidatorMapFunc = (key, newValue, oldValue, changes, content) => {
    const conditionPassed = condition(key, newValue, oldValue, changes, content);
    const validator = conditionPassed ? thenValidator : elseValidator;
    return !validator || validator(key, newValue, oldValue, changes, content);
  };

  return validator;
}
